import { render, staticRenderFns } from "./download-page.vue?vue&type=template&id=15294886"
import script from "./download-page.vue?vue&type=script&lang=js"
export * from "./download-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15294886')) {
      api.createRecord('15294886', component.options)
    } else {
      api.reload('15294886', component.options)
    }
    module.hot.accept("./download-page.vue?vue&type=template&id=15294886", function () {
      api.rerender('15294886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Download/download-page.vue"
export default component.exports